import React, { useState } from "react";
import Tesseract from "tesseract.js";

const labelStyle = {
    display: "inline-block",
    paddingRight: "1 em"
};

const OcrTool = () => {
    const [language, setLanguage] = useState("eng");
    const [url, setUrl] = useState("https://tesseract.projectnaptha.com/img/eng_bw.png");
    const [urlResult, setUrlResult] = useState("");
    const [uploadResult, setUploadResult] = useState("");
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleExtractFromUrl = async () => {
        setLoading(true);
        setUrlResult("Processing...");
        try {
            const { data: { text } } = await Tesseract.recognize(url, language, {
                logger: info => console.log(info)
            });
            setUrlResult(text || "No text found in image");
        } catch (err) {
            setUrlResult("Error: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setUploadResult("");
        }
    };

    const handleProcessUpload = async (file) => {
        if (!file) {
            alert("Please select an image first");
            return;
        }
        setLoading(true);
        setUploadResult("Processing...");
        try {
            const reader = new FileReader();
            reader.onload = async () => {
                const { data: { text } } = await Tesseract.recognize(reader.result, language, {
                    logger: info => console.log(info)
                });
                setUploadResult(text || "No text found in image");
                setLoading(false);
            };
            reader.readAsDataURL(file);
        } catch (err) {
            setUploadResult("Error: " + err.message);
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <h2 className="text-center mb-4">🖼️ OCR Image to Text Converter</h2>

            {/* Language Selector */}
            <div className="mb-4 text-center">
                <label htmlFor="lang-select" style={labelStyle} className="form-label fw-bold">Choose OCR Language</label>
                <select
                    id="lang-select"
                    className="form-select w-auto d-inline-block"
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                >
                    <option value="eng">English</option>
                    <option value="hin">Hindi</option>
                    <option value="mar">Marathi</option>
                    <option value="tam">Tamil</option>
                    <option value="tel">Telugu</option>
                    <option value="ben">Bengali</option>
                    <option value="guj">Gujarati</option>
                    <option value="kan">Kannada</option>
                    <option value="mal">Malayalam</option>
                    <option value="pan">Punjabi</option>
                    <option value="urd">Urdu</option>
                </select>
            </div>

            {/* Tabs */}
            <ul className="nav nav-tabs" id="ocrTabs" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="url-tab" data-bs-toggle="tab" data-bs-target="#url" type="button" role="tab">
                        From Image URL
                    </button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="upload-tab" data-bs-toggle="tab" data-bs-target="#upload" type="button" role="tab">
                        Upload Image
                    </button>
                </li>
            </ul>

            <div className="tab-content p-4 border border-top-0 bg-white rounded-bottom shadow-sm" id="ocrTabsContent">

                {/* URL OCR */}
                <div className="tab-pane fade show active" id="url" role="tabpanel">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title">Extract Text from Image URL</h5>
                            <div className="mb-3">
                                <label htmlFor="image-url" className="form-label">Image URL</label>
                                <input
                                    type="text"
                                    id="image-url"
                                    className="form-control"
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                />
                            </div>
                            <button className="btn btn-primary" onClick={handleExtractFromUrl}>Extract Text</button>
                            <div className="mt-4">
                                <h6>Result:</h6>
                                <div className="card p-3 bg-light border" style={{ minHeight: "80px" }}>
                                    {loading ? "Processing..." : urlResult}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Upload OCR */}
                <div className="tab-pane fade" id="upload" role="tabpanel">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title">Extract Text from Uploaded Image</h5>
                            <div className="mb-3">
                                <label htmlFor="image-input" className="form-label">Select Image File</label>
                                <input
                                    type="file"
                                    id="image-input"
                                    className="form-control"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                            </div>
                            <button
                                className="btn btn-success"
                                onClick={() => handleProcessUpload(document.getElementById("image-input").files[0])}
                            >
                                Process Image
                            </button>
                            {preview && (
                                <div className="mt-4">
                                    <h6>Preview:</h6>
                                    <img src={preview} alt="Preview" className="img-fluid rounded border" style={{ maxWidth: "500px" }} />
                                </div>
                            )}
                            <div className="mt-4">
                                <h6>Extracted Text:</h6>
                                <div className="card p-3 bg-light border" style={{ minHeight: "80px" }}>
                                    {loading ? "Processing..." : uploadResult}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default OcrTool;
